import type { TFunction } from 'i18next';

import { uniqueOptions, type FilterDef } from '@nucleus-commerce/admin-kit/index-table';
import type { TaxRate } from '@nucleus-commerce/api-client/admin';

import { countryName } from '@/features/markets';

import type { TaxRateStatus } from './tax-rate-columns';

const STATUSES: readonly TaxRateStatus[] = ['active', 'inactive'];

/** Filters of the tax rates table; `t` is the `tax` namespace. Countries come from the loaded rates. */
export function taxRateFilters(t: TFunction, rates: readonly TaxRate[]): Array<FilterDef<TaxRate>> {
  return [
    {
      key: 'country',
      label: t('columns.country'),
      type: 'enum',
      pinned: true,
      getValue: (row) => row.countryCode,
      options: uniqueOptions(rates, (rate) => rate.countryCode, countryName),
    },
    {
      key: 'status',
      label: t('columns.active'),
      type: 'enum',
      pinned: true,
      options: STATUSES.map((status) => ({ value: status, label: t(`status.${status}`) })),
    },
  ];
}
